import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryScriptPromptAttributes } from './generated/DiscoveryScriptPromptAttributes';
import { model } from '../modelBuilder';

interface DiscoveryScriptPrompt extends DiscoveryScriptPromptAttributes {}

@model
class DiscoveryScriptPrompt extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryScriptPrompt' = 'DiscoveryScriptPrompt';
  get typename(): 'DiscoveryScriptPrompt' {
    return 'DiscoveryScriptPrompt';
  }

  static internalTypename: 'Discovery::ScriptPrompt' =
    'Discovery::ScriptPrompt';
  get internalTypename(): 'Discovery::ScriptPrompt' {
    return 'Discovery::ScriptPrompt';
  }

  static inputType = 'DiscoveryScriptPromptAttributes!';

  static filterType = 'ScriptPromptFilters!';
  static filters = {
    id: '[ID!]',
    discoveryStudyId: 'ID',
    discoveryScriptId: 'ID',
    discoveryStudy: 'DiscoveryStudyRelationshipInput',
  };

  static fields = {
    createdAt: attr({ readable: true }),
    discoveryScriptId: attr({ readable: true }),
    discoveryScriptPromptUsesCount: attr({ readable: true }),
    guidance: attr({ writable: true, readable: true }),
    id: attr({ readable: true }),
    position: attr({ writable: true, readable: true }),
    prompt: attr({ writable: true, readable: true }),
    updatedAt: attr({ readable: true }),
    discoveryScript: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'DiscoveryScript',
    }),
    discoveryStudy: attr.belongsTo({ writeShape: ['id'], readable: false }),
    discoveryScriptPromptUses: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  positionInList(list: DiscoveryScriptPrompt[]): number {
    return list.findIndex(item => item.id === this.id);
  }
}

export default DiscoveryScriptPrompt;
